import { render, staticRenderFns } from "./Finish.vue?vue&type=template&id=3b13f0d5&scoped=true"
import script from "./Finish.vue?vue&type=script&lang=ts"
export * from "./Finish.vue?vue&type=script&lang=ts"
import style0 from "./Finish.vue?vue&type=style&index=0&id=3b13f0d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b13f0d5",
  null
  
)

export default component.exports